import { render, staticRenderFns } from "./approvalConfig.vue?vue&type=template&id=45c93bdb&scoped=true"
import script from "./approvalConfig.vue?vue&type=script&lang=js"
export * from "./approvalConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c93bdb",
  null
  
)

export default component.exports